<!-- <div>
<ion-grid>
  <ion-row>
    <h1 class="emoji-syndicate-leave">😞</h1>
  </ion-row>
  <ion-row>
    <h1 class="dialog-header">{{'syndicate-leave.win' | translate}}</h1>
  </ion-row>
  <ion-row>
    <p class="dialog-content">{{'syndicate-leave.sure' | translate}}</p>
  </ion-row>
  <ion-row>
    <ion-button expand="block" color="medium" class="capsule-btn common-margin" type="submit"
      (click)="leaveSyndicate(); startSpinner()">
      <span *ngIf="!spinnerAnimation && proceed">{{'syndicate-leave.want' | translate}}</span>
      <div *ngIf="spinnerAnimation" class="spinners">
        <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
        </mat-progress-spinner>
      </div>
      <mat-icon *ngIf="!proceed" [@bounceIn] class="tick-mark">done</mat-icon>
    </ion-button>
  </ion-row>
  <ion-row>
    <h1 class="keep-playing-txt" (click)="closeModal()">{{'syndicate-leave.playing' | translate}}</h1>
  </ion-row>
</ion-grid>
</div> -->

<div class="for-position">
  <img src="../../../../assets/images/leavebg-circle.png" alt="" class="bg-circle">
  <ion-grid>
    <ion-row>
      <h1 class="emoji-syndicate-leave">😞</h1>
    </ion-row>
    <ion-row>
      <h1 class="dialog-header">{{'syndicate-leave.win' | translate}}</h1>
    </ion-row>
    <!-- <ion-row>
    <p class="dialog-content">{{'syndicate-leave.sure' | translate}}</p>
  </ion-row> -->
  <!-- newly added -->
  <ion-row class="benfit-text">
    <p>{{'syndicate-leave.benifit' | translate}}</p>
  </ion-row>
  <ion-row class="displays  top-align ">
    <small>&bull;</small>
    <p> <span>{{'syndicate-leave.Automatic_entry' | translate}}</span> {{'syndicate-leave.every_draw' | translate }}
  </p>
</ion-row>
<ion-row class="displays ">
  <small>&bull;</small>
  <p><span>{{'syndicate-leave.one_off' | translate}}</span> {{'syndicate-leave.lottery' | translate }}</p>
</ion-row>
<ion-row class="displays display-last-div ">
  <small>&bull;</small>
  <p class="long-text">{{'syndicate-leave.smart_way' | translate}}<span> {{'syndicate-leave.more_lines' |
  translate}}</span></p>
</ion-row>
<ion-row>
  <ion-button expand="block" color="medium" class="capsule-btn common-margin" type="submit"
    (click)="pauseWithCredit(); startSpinner()">
    @if (!spinnerAnimation && proceed) {
      <span>
        {{ isClaimed ? ('syndicate-leave.pause_syndicate' | translate) : pause2Credit }}
      </span>
    }
    @if (spinnerAnimation) {
      <div class="spinners">
        <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
        </mat-progress-spinner>
      </div>
    }
    @if (!proceed) {
      <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
    }
  </ion-button>
</ion-row>
<ion-row>
  <h1 class="keep-playing-txt" (click)="confirmLeaveReason();">{{'syndicate-leave.no_thanks' | translate}}</h1>
</ion-row>
</ion-grid>
</div>